import { useState } from 'react';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import Modal from '../Modal';
import { FileUploader } from '../../UI';
import { uploadRemittance } from '../../../store/actions/authActionCreator';
import { showMessage } from '../../../utils/helper';

function UploadRemittanceModal({
    open,
    onClose,
    source = 'staffPay',
    dispatchUploadRemittance,
}) {
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);

    const dispatch = useDispatch();
    const handleClose = () => {
        setFile(null);
        setLoading(false);
        onClose?.();
    };

    const handleUpload = async () => {
        if (!file) {
            showMessage('Please upload file', 'error');
            return;
        }
        if (!file?.name?.endsWith('.csv')) {
            showMessage('Invalid file format. Please upload .csv', 'error');
            return;
        }

        setLoading(true);
        try {
            dispatch(
                uploadRemittance(
                    file,
                    () => {
                        setLoading(false);
                        showMessage(
                            'Remittance uploaded successfully!',
                            'success',
                        );
                        handleClose();
                    },
                    (error) => {
                        console.error('Remittance upload failed', error);
                        setLoading(false);
                        showMessage('Failed to upload remittance', 'error');
                        handleClose();
                    },
                ),
            );
        } catch (err) {
            console.error('Unexpected error during upload', err);
            setLoading(false);
            showMessage('Failed to upload remittance', 'error');
            handleClose();
        }
    };

    const actions = [
        <Button
            key={1}
            variant="contained"
            color="default"
            className={`cancelButton`}
            onClick={handleClose}
            disableElevation
        >
            {'Cancel'}
        </Button>,
        <Button
            key={2}
            variant="contained"
            color="primary"
            className={`saveButton`}
            disabled={!file || loading}
            disableElevation
            onClick={handleUpload}
        >
            Upload Remittance
        </Button>,
    ];

    return (
        <Modal
            onClose={handleClose}
            open={open}
            title={source == 'zappay' ? 'Upload Remittance' : ''}
            subtitle={source == 'zappay' ? 'Upload Remittance File' : ''}
            actions={actions}
            loading={loading}
            containerStyle={{ width: '100%' }}
        >
            <FileUploader
                label="Upload file"
                placeholder="Choose a remittance file"
                disableS3Upload={true}
                onFileUploaded={(selectedFile) => {
                    setFile(selectedFile);
                }}
                isRequired={true}
            />
        </Modal>
    );
}

export default UploadRemittanceModal;
